if (!customElements.get('related-products-slider')) {
  customElements.define(
    'related-products-slider',
    class RelatedProductsSlider extends HTMLElement {
      // <product-recommendations> swaps its innerHTML once recommendations load, which removes this
      // element and inserts a fresh copy. Init/teardown therefore live in connected/disconnected only,
      // so each copy owns exactly one Swiper instance and never touches the other's DOM.
      connectedCallback() {
        if (this.swiper || typeof Swiper === 'undefined') return;

        const viewport = this.querySelector('[data-slider-viewport]');
        if (!viewport) return;

        this.swiper = new Swiper(viewport, {
          // Theme class names, so swiper-bundle.min.css isn't needed.
          wrapperClass: 'related-products__grid',
          slideClass: 'related-products__item',
          slidesPerView: 1.2,
          spaceBetween: 16,
          watchOverflow: true,
          grabCursor: true,
          navigation: {
            prevEl: this.querySelector('[data-slider-prev]'),
            nextEl: this.querySelector('[data-slider-next]'),
          },
          breakpoints: {
            430: { slidesPerView: 2.2, spaceBetween: 16 },
            750: { slidesPerView: 3.3, spaceBetween: 20 },
            1150: { slidesPerView: 4, spaceBetween: 20 },
          },
        });
      }

      disconnectedCallback() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
